<template>
  <div class="naj-map">
    <label v-if="title" class="headline">{{ title }}</label>
    <div class="map preview-map">
      <gmap-map
        v-if="isPointSelected"
        :options="previewMapOptions"
        :zoom="previewZoom"
        :center="selectedPoint"
      >
        <gmap-marker :position="selectedPoint"></gmap-marker>
      </gmap-map>
      <naj-button
        :class="['open-modal-button', { 'point-selected': isPointSelected }]"
        @click="openModal"
      >
        {{ buttonText }}
      </naj-button>
    </div>
    <naj-modal
      :title="local.changeAuditPath.modalTitle"
      :width="900"
      :footer="true"
      show-footer-close-button
      ref="mapModal"
      @onClose="onModalClose"
    >
      <div class="map editable-map">
        <gmap-map
          :options="mapOptions"
          ref="mapRef"
          :zoom="zoom"
          :center="centerPoint"
          @click="mapClicked"
        >
          <gmap-marker
            v-if="isMarkerVisible"
            :position="markerPoint"
            :draggable="true"
            @dragend="markerDragend"
          ></gmap-marker>
        </gmap-map>
      </div>
      <template slot="actions" slot-scope="{ closeNajModal }">
        <naj-button @click="resetMarkerPoint" outlined>{{ resetText }}</naj-button>
        <naj-button @click="submit(closeNajModal)">{{ submitButtonText }}</naj-button>
      </template>
    </naj-modal>
    <naj-error-text v-if="errorMessage" :text="errorMessage"></naj-error-text>
  </div>
</template>

<script>
const defaultPoint = () => ({
  lat: null,
  lng: null,
});
export default {
  name: 'naj-map',
  $_veeValidate: {
    name () {
      return this.title;
    },
    value () {
      return this.value ? `${this.value.lat}${this.value.lng}` : this.value;
    },
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    zoom: {
      type: Number,
      default: 5,
    },
    previewZoom: {
      type: Number,
      default: 10,
    },
    errorMessage: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      selectedPoint: defaultPoint(),
      markerPoint: defaultPoint(),
      resetText: 'إعادة تعيين',
      defaultOptions: {
        disableDefaultUI: true,
      },
      centerPoint: {
        lat: 24.44001096444439,
        lng: 46.82649666353443,
      },
    };
  },
  computed: {
    isMarkerVisible () {
      return this.markerPoint.lat && this.markerPoint.lng;
    },
    isPointSelected () {
      return this.selectedPoint.lat && this.selectedPoint.lng;
    },
    buttonText () {
      const chooseText = 'اختر موقعك على الخريطة';
      const updateText = 'تعديل موقعك على الخريطة';
      return this.isPointSelected ? updateText : chooseText;
    },
    submitButtonText () {
      const saveText = this.local.common.save;
      const updateText = this.local.common.update;
      return this.isPointSelected ? updateText : saveText;
    },
    mapOptions () {
      return { ...this.defaultOptions };
    },
    previewMapOptions () {
      return { ...this.defaultOptions };
    },
  },
  methods: {
    mapClicked (e) {
      this.updateMarkerPoint(e.latLng);
    },
    markerDragend (e) {
      this.updateMarkerPoint(e.latLng);
    },
    updateMarkerPoint (latLngObj) {
      this.markerPoint = { lat: latLngObj.lat(), lng: latLngObj.lng() };
    },
    resetMarkerPoint () {
      this.markerPoint = defaultPoint();
    },
    resetPoint () {
      this.markerPoint = this.selectedPoint = defaultPoint();
    },
    submit (closeModal) {
      this.selectedPoint = { ...this.markerPoint };
      this.$emit('update:value', this.selectedPoint);
      closeModal();
    },
    openModal () {
      this.$refs.mapModal.show();
    },
    onModalClose () {
      this.markerPoint = { ...this.selectedPoint };
    },
    updateMapValue () {
      if (this.value) {
        this.selectedPoint = this.markerPoint = this.centerPoint = this.value
          ? { ...this.value }
          : defaultPoint();
      }
    },
  },
  mounted () {
    this.updateMapValue();
  },
  watch: {
    value () {
      this.updateMapValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.naj-map {
  .title {
    display: block;
    font-size: 25px !important;
    font-weight: 500;
    transform: scale(0.75);
    transform-origin: top right;
    color: #000;
    line-height: 25px;
  }
}
.map {
  &.preview-map {
    width: 300px;
    height: 200px;
    margin-bottom: 10px;
    position: relative;
    background: #eee;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    .open-modal-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      &.point-selected {
        opacity: 0;
      }
    }
    &:hover {
      .open-modal-button {
        opacity: 1;
      }
    }
  }
  &.editable-map {
    height: 350px;
  }
  ::v-deep {
    .vue-map-container,
    .vue-map-container .vue-map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
